jQuery(document).ready(function ($) {

    $('.brands__item').on('click', function (e) {
        var id = $(this).data("id");
        $('.brands__item').removeClass('active');
        $('.brands-info__box').removeClass('active');
        $('.brands-info__box[data-id="' + id + '"]').addClass('active');
        $(this).addClass('active');
    });

    $('.brands-info-close').on('click', function (e) {
        $('.brands__item').removeClass('active');
        $('.brands-info__box').removeClass('active');
    });


    $('.load-more-btn').on('click', function (e) {
        $(this).toggleClass('is-loaded');
    });
});